var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCustomersOnDemand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 61,
    viewBox: "0 0 77 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.6929 19.7571C76.6929 35.6116 40.8746 60.904 25.0201 60.904C9.16562 60.904 0.140625 44.7022 0.140625 28.8477C0.140625 12.9932 12.9932 0.140625 28.8477 0.140625C44.7022 0.140625 76.6929 3.90265 76.6929 19.7571Z",
    fill: "#FFE5E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8641 19.408C37.8641 22.6782 35.2131 25.329 31.9432 25.329C28.6746 25.329 26.0234 22.678 26.0234 19.408C26.0234 16.1378 28.6744 13.4871 31.9432 13.4871C35.2133 13.4871 37.8641 16.138 37.8641 19.408Z",
    fill: "#FE5F55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8106 28.7088C39.2586 27.0254 37.0321 25.9739 34.5633 25.9739H29.1219C24.4184 25.9739 20.6133 29.7793 20.6133 34.4764V39.6454H25.2329V33.5229C25.2329 33.1397 25.5464 32.8277 25.9281 32.8277C26.3113 32.8277 26.6233 33.1413 26.6233 33.5229V39.6454H36.3846L37.8526 28.7087L40.8106 28.7088Z",
    fill: "#FE5F55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6723 39.6651L49.3928 30.0984H47.2992V31.872C47.2992 32.2553 46.9857 32.5672 46.6041 32.5672C46.2208 32.5672 45.9089 32.2537 45.9089 31.872V30.0984H42.5548V31.872C42.5548 32.2553 42.2412 32.5672 41.8596 32.5672C41.4764 32.5672 41.1644 32.2537 41.1644 31.872V30.0984H39.0708L37.7913 39.6651C37.701 40.3477 38.23 40.9447 38.9109 40.9447H49.5561C50.2338 40.9463 50.7626 40.3476 50.6723 39.6651Z",
    fill: "#FE5F55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5558 28.9732C42.5558 28.0548 43.3065 27.3041 44.2329 27.3041C45.1577 27.3041 45.9099 28.0548 45.9099 28.9732V30.1008H47.3019V28.9732C47.3019 27.2819 45.9242 25.9121 44.2345 25.9121C42.5431 25.9121 41.167 27.2835 41.167 28.9732V30.1008H42.559L42.5558 28.9732Z",
    fill: "#FE5F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCustomersOnDemand);
export default __webpack_public_path__ + "static/media/NewCustomersOn-Demand.cf13d7c8f2efd23d2523bdc5a14a0c9c.svg";
export { ForwardRef as ReactComponent };